// Helpers puros sobre pictogramas del visor de parque solar.

// Devuelve los pictogramas cuyo id está en la lista `ids`.
export function filterPictogramsByIds(pictograms, ids) {
  return pictograms.filter((item) => ids.includes(item.id))
}
